export const vjChannel = new BroadcastChannel("vj");
